import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72df09d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "video-wrapper",
  ref: "video-wrapper"
}
const _hoisted_2 = ["width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", {
      ref: "player",
      tabindex: "0",
      controls: "",
      width: _ctx.playerWidth,
      height: _ctx.playerHeight,
      autoplay: true,
      id: "vpl",
      class: "max-width"
    }, null, 8, _hoisted_2)
  ], 512))
}